import { PLUGIN_TITLE_GLOSSARY } from '#shared/constants/common';
import yup from '#shared/utils/yup';
import pluginId from '../pluginId';
const VALIDATION_MESSAGES = {
  term: 'The term field is required',
  businessLine: 'Please select a business line'
};
export const GLOSSARY_TERM_LIST_QUERY_WITH_PARAMS = '?page=1&pageSize=10&sort=createdAt:DESC';
export const TYPOGRAPHY = {
  common: {
    pluginName: PLUGIN_TITLE_GLOSSARY,
    activities: 'Activities',
    createButton: 'Create new',
    saveButton: 'Save'
  },
  header: {
    entriesLabel: 'entries found'
  },
  filter: {
    resetFiltersTooltip: 'Reset filters',
    searchPlaceholder: 'Search by term'
  },
  homePage: {
    actions: 'actions',
    editButton: 'Edit Glossary Term'
  },
  createPage: {
    title: 'Glossary Term',
    block: {
      info: 'Glossary Term information'
    }
  },
  editPage: {
    title: 'Edit Glossary Term',
    relations: 'Relations',
    newRelations: 'Relations (Activity editor)'
  }
};
export const ROUTES = {
  homePage: `/plugins/${pluginId}`,
  createPage: `/plugins/${pluginId}/create`,
  editPage: `/plugins/${pluginId}/edit/:glossaryTermId`
};
export const TABLE_FIELDS = {
  id: {
    label: 'Id',
    name: 'id'
  },
  term: {
    label: 'Term',
    name: 'term'
  },
  definition: {
    label: 'Definition',
    name: 'definition'
  },
  uuid: {
    label: 'Uuid',
    name: 'uuid'
  },
  businessLine: {
    label: 'Business line',
    name: 'business_line'
  },
  createdAt: {
    label: 'Created at',
    name: 'createdAt'
  }
};
export const MESSAGES = {
  error: {
    default: 'Something went wrong',
    notFound: 'Couldn\'t find glossary term with id',
    create: 'Failed to create a new glossary term. Please try again',
    update: 'Failed update glossary term. Please try again'
  },
  success: {
    create: 'The glossary term was successfully created',
    update: 'The glossary term was been successfully updated'
  }
};
export const VALIDATION_SCHEMA = yup.object().shape({
  term: yup.string().required(VALIDATION_MESSAGES.term),
  business_line: yup.string().required(VALIDATION_MESSAGES.businessLine)
});